<template>
  <div>{{ groupName }}</div>
</template>

<script>
export default {
  name: "AssetType",
  props: {
    assetType: {
      type: Number,
      required: true
    }
  },
  computed: {
    groupName() {
      switch (this.assetType) {
        case 1:
          return this.$t('stocks')
        case 2:
          return this.$t('funds')
        case 3:
          return this.$t('bonds')
        case 4:
          return this.$t('currency')
      }
    }
  },
  i18n: {
    messages: {
      en: {
        stocks: 'Stocks',
        funds: 'Funds',
        bonds: 'Bonds',
        currency: 'Currency'
      },
      ru: {
        stocks: 'Акции',
        funds: 'Облигации',
        bonds: 'Фонды',
        currency: 'Валюта'
      }
    }
  }
}
</script>